module.exports = __webpack_public_path__ + "static/media/alert.97935d54.mp3";